import { gql } from 'graphql-request';

export default gql`
  query($lat: Float, $lon: Float, $currentPage: PositiveInt) {
    accommodations(perPage: 6, lat: $lat, lon: $lon, page: $currentPage) {
      items {
        site {
          port
          hostname
        }
        name
        url
        distance
        streetName
        postCode
        houseNumber
        city
        promotionImage {
          img: rendition(fill: "330x220-c100") {
            url
          }
        }
      }
      pagination {
        total
        count
        prevPage
        nextPage
        totalPages
        currentPage
      }
    }
  }
`;
